import { render, staticRenderFns } from "./Triage.vue?vue&type=template&id=25d333c2&"
import script from "./Triage.vue?vue&type=script&lang=js&"
export * from "./Triage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports